import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import Splide from '@splidejs/splide';

export const imageGalleryBehavior = () => {
  Alpine.data('imageGalleryBehavior', () => ({
    carouselIsShowing: false,
    carousel: undefined,
    init() {
      // When modal appears, refresh carousel to ensure its on the correct slide.
      this.watch('carouselIsShowing');
      this.initSlider();
    },
    initSlider() {
      // Always mount the thumbails.
      const galleryThumbnails = this.$el.querySelector('.image-gallery-thumbnails');
      const thumbnails = new Splide(galleryThumbnails, {
        pagination: false,
        arrows: false,
        isNavigation: true,
      });
      thumbnails.mount();

      if (this.carousel === undefined && this.$el.querySelector('.m-carousel')) {
        this.carousel = new Splide(this.$el.querySelector('.m-carousel'), {
          rewind: true,
          pagination: true,
          arrows: true,
          type: 'loop',
          focus: 'center',
          perPage: 1,
          mediaQuery: 'min',
          gap: '2.25rem',
          breakpoints: {
            768: {
              perPage: 1,
              gap: '5rem',
              padding: '5rem',
            },
            1024: {
              gap: '10rem',
            },
          },
        });
        this.carousel.sync(thumbnails);
        this.carousel.mount();
      }
    },
    watch(property) {
      this.$watch(property, (newValue) => {
        if (newValue === true) {
          setTimeout(() => {
            this.refreshCarousel();
          }, 50);
        }
      });
    },
    refreshCarousel() {
      this.carousel.refresh();
    },
  }));
};
